var paragraph_default = {
  "fontElementMap": "x-yoy",
  "elementSpacing": "FKZMr",
  "text": "YkmxR FKZMr",
  "child": "B6ypb"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
